import { useSelectedNumberByVariableKey } from '@k3/core'
import { useVerandaSelector } from '../../../../'
import { Helper } from '../../../../classes/helper'
import { useMeasures } from '../../../../hooks/state/useMeasures'
import { Ruler } from './Ruler'

export interface RulerInformation {
  name: string
  length: number
  startPoint: number[]
  endPoint: number[]
  direction: 'x' | 'y' | 'z'
  pos: 'links | rechts'
  textPosition: number[]
  textRotation: number[]
}

export const Rulers = ({}) => {
  const alignment = useVerandaSelector((state) => state.scene.alignment)
  const {
    eaves,
    eavesHeight,
    eavesWidth,
    frontHeight,
    verandaTyp,
    staticLogPosition,
    stringStaticDynamicLog,
    userAngle,
    attachedSize,
    isQuer,
    isQubus,
  } = useMeasures()
  0

  const widthLabel = (useSelectedNumberByVariableKey('width') as number) / 100
  const width = widthLabel

  const height = (useSelectedNumberByVariableKey('height') as number) / 100
  const tiefe = ((useSelectedNumberByVariableKey('depth') as number) /
    100) as number

  const frontLogHeight = isQubus
    ? height
    : eaves
    ? eavesHeight -
      Helper.calculateTriangle(staticLogPosition, userAngle, 90).b / 2
    : frontHeight - (stringStaticDynamicLog ? staticLogPosition : 0)

  const barHeight =
    verandaTyp.bar.width && isQubus ? verandaTyp.bar.width : attachedSize.y

  return (
    <>
      {[
        {
          name: 'breite',
          length: widthLabel * 100,
          startPoint: [-width / 2, 0.05, tiefe + 0.5],
          endPoint: [width / 2, 0.05, tiefe + 0.5],
          direction: 'x',
          textPosition: [0, 0.05, tiefe + 0.5],
          textRotation: [-Math.PI / 2, 0, 0],
        },

        {
          name: 'höhe1',
          length: barHeight * 100,
          startPoint: [-width / 2 - 0.5, height, 0.1],
          endPoint: [-width / 2 - 0.5, height + barHeight, 0.1],
          direction: 'y',
          pos: 'links',
          textPosition: [-width / 2 - 0.5, height + barHeight / 2 - 0.02, 0.1],
          textRotation: [0, 0, 0],
        },
        {
          name: 'höhe2',
          length: height * 100,
          startPoint: [-width / 2 - 0.5, 0.005, 0.1],
          endPoint: [-width / 2 - 0.5, height, 0.1],
          direction: 'y',
          pos: 'links',
          textPosition: [-width / 2 - 0.5, height / 2 - 0.01, 0.1],
          textRotation: [0, 0, 0],
        },
        {
          name: 'höheVorne',
          length: frontLogHeight * 100,
          startPoint: [
            -width / 2 - 0.5,
            0.01,
            tiefe + 0.08 - (eaves ? eavesWidth : 0),
          ],
          endPoint: [
            -width / 2 - 0.5,
            frontLogHeight,
            tiefe + 0.08 - (eaves ? eavesWidth : 0),
          ],
          direction: 'y',
          pos: 'links',
          textPosition: [
            -width / 2 - 0.5,
            frontLogHeight / 2,
            tiefe + 0.08 - (eaves ? eavesWidth : 0),
          ],
          textRotation: [0, 0, 0],
        },
        isQuer
          ? {
              name: 'tiefe',
              length: tiefe * 100,
              startPoint: [width / 2 + 0.5, 0.05, 0],
              endPoint: [width / 2 + 0.5, 0.05, tiefe],
              rotate: [0, Math.PI / 2, 0],
              direction: 'z',
              textPosition: [width / 2 + 0.5, 0.05, tiefe / 2],
              textRotation: [-Math.PI / 2, 0, Math.PI / 2],
            }
          : {
              name: 'tiefe',
              length: tiefe * 100,
              startPoint: [-width / 2 - 0.5, 0.05, 0],
              endPoint: [-width / 2 - 0.5, 0.05, tiefe],
              rotate: [0, Math.PI / 2, 0],
              direction: 'z',
              textPosition: [-width / 2 - 0.5, 0.05, tiefe / 2],
              textRotation: [-Math.PI / 2, 0, Math.PI / 2],
            },
      ].map((rule, id) => {
        if (Object.keys(rule).length !== 0) {
          return (
            alignment && (
              <Ruler rule={rule as RulerInformation} key={'Rule' + id} />
            )
          )
        }
        return null
      })}
    </>
  )
}
